module.exports = __webpack_public_path__ + "img/scalable.33e56148.png";